var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"uk-modal-close-default",attrs:{"type":"button","uk-close":""}}),_c('div',{staticClass:"uk-modal-header"},[_c('h2',{staticClass:"uk-modal-title"},[_vm._t("default")],2)]),_c('div',{staticClass:"uk-modal-body",attrs:{"uk-overflow-auto":""}},[_c('Autocomplete',{attrs:{"dropdownMode":false,"placeholder":_vm.asset
          ? 'Search for new parent folder'
          : _vm.product
          ? 'Search for new leaf parent category'
          : 'Search for new parent category',"data":_vm.dataList},on:{"updateField":_vm.updateField,"keyChange":_vm.autoCompleteFetch}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }